import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import {
  CalculateTourEss,
  EMPTY_CALCULATE_TOUR_ESS,
} from '@/domain/impact-calculate-tour/entities/calculate-tour-ess.entity';

import { ResultsTourDto } from '../dto.type';

export function mapEss(dto: ResultsTourDto): CalculateTourEss {
  return dto.general.ess
    ? {
        general: {
          scoreLetter: getScoreLetterFromScore(
            dto.general.ess.score / dto.general.ess.maxScore,
          ),
          score: dto.general.ess.score,
          maxScore: dto.general.ess.maxScore,
          topics: {
            PARITY_EQUALITY: {
              score: dto.general.ess.topics.PARITY_EQUALITY.score,
              maxScore: dto.general.ess.topics.PARITY_EQUALITY.maxScore,
              sections: {
                ARTISTIC_TEAM: {
                  score:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .ARTISTIC_TEAM.score,
                  maxScore:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .ARTISTIC_TEAM.maxScore,
                },
                OCCASIONAL_OPERATIONAL_TEAM: {
                  score:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .OCCASIONAL_OPERATIONAL_TEAM.score,
                  maxScore:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .OCCASIONAL_OPERATIONAL_TEAM.maxScore,
                },
                PERMANENT_PRODUCTION_TEAM: {
                  score:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .PERMANENT_PRODUCTION_TEAM.score,
                  maxScore:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .PERMANENT_PRODUCTION_TEAM.maxScore,
                },
                TRANSPARENCY_MANAGEMENT: {
                  score:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .TRANSPARENCY_MANAGEMENT.score,
                  maxScore:
                    dto.general.ess.topics.PARITY_EQUALITY.sections
                      .TRANSPARENCY_MANAGEMENT.maxScore,
                },
              },
            },
            LOCAL_IMPACT_RSE_ENGAGEMENT: {
              score: dto.general.ess.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.score,
              maxScore:
                dto.general.ess.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.maxScore,
              sections: {
                ECONOMIC_SOCIAL_IMPACT: {
                  score:
                    dto.general.ess.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                      .ECONOMIC_SOCIAL_IMPACT.score,
                  maxScore:
                    dto.general.ess.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                      .ECONOMIC_SOCIAL_IMPACT.maxScore,
                },
              },
            },
            ACCESSIBILITY_SOCIAL_DIALOGUE: {
              score: dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.score,
              maxScore:
                dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.maxScore,
              sections: {
                ACCESSIBILITY: {
                  score:
                    dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                      .sections.ACCESSIBILITY.score,
                  maxScore:
                    dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                      .sections.ACCESSIBILITY.maxScore,
                },
                RISK_PREVENTION: {
                  score:
                    dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                      .sections.RISK_PREVENTION.score,
                  maxScore:
                    dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                      .sections.RISK_PREVENTION.maxScore,
                },
                TEAM_MANAGEMENT: {
                  score:
                    dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                      .sections.TEAM_MANAGEMENT.score,
                  maxScore:
                    dto.general.ess.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                      .sections.TEAM_MANAGEMENT.maxScore,
                },
              },
            },
          },
        },
      }
    : EMPTY_CALCULATE_TOUR_ESS;
}
